import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

const MP = { amazon: "text-[#F59E0B]", flipkart: "text-[#60A5FA]", firstcry: "text-[#F472B6]", myntra: "text-[#E879F9]", unknown: "text-slate-400" };

const fmtDay = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  const today = new Date();
  const isToday = d.toDateString() === today.toDateString();
  return isToday ? "Today" : d.toLocaleDateString(undefined, { weekday: "short", day: "numeric", month: "short" });
};

export const DailySummary = ({ refreshKey }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/summary/daily", { params: { days: 7 } }).then((r) => setData(r.data)).catch(() => {}); }, [refreshKey]);
  if (!data) return null;
  return (
    <div className="space-y-3" data-testid="daily-summary-section">
      <div className="flex items-baseline justify-between">
        <h2 className="font-heading text-lg font-bold uppercase tracking-tight sm:text-xl">Daily summary</h2>
        <span className="font-mono text-[11px] uppercase tracking-widest text-slate-500">last 7 days · IST</span>
      </div>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-7">
        {data.days.map((d, i) => (
          <div key={d.date} data-testid={`daily-card-${d.date}`} className={cn("stat-card rounded-md border bg-[#111827] p-4", i === 0 ? "border-blue-700/60" : "border-slate-800", d.received === 0 && d.printed === 0 && "opacity-60")}>
            <div className="font-mono text-[11px] uppercase tracking-widest text-slate-400">{fmtDay(d.date)}</div>
            <div className="mt-2 grid grid-cols-3 gap-1 text-center">
              <div><div className="font-heading text-2xl font-extrabold">{d.received}</div><div className="font-mono text-[9px] uppercase tracking-widest text-slate-500">in</div></div>
              <div><div className="font-heading text-2xl font-extrabold text-emerald-300">{d.printed}</div><div className="font-mono text-[9px] uppercase tracking-widest text-slate-500">printed</div></div>
              <div><div className={cn("font-heading text-2xl font-extrabold", d.pending ? "text-amber-300" : "text-slate-500")}>{d.pending}</div><div className="font-mono text-[9px] uppercase tracking-widest text-slate-500">pending</div></div>
            </div>
            <div className="mt-3 space-y-0.5 border-t border-slate-800 pt-2">
              {["amazon", "flipkart", "firstcry", "myntra"].map((m) => {
                const s = d.by_marketplace[m];
                if (!s || (s.received === 0 && s.printed === 0)) return null;
                return (
                  <div key={m} className="flex justify-between font-mono text-[10px]">
                    <span className={cn("uppercase tracking-widest", MP[m])}>{m}</span>
                    <span className="text-slate-400">{s.received} in · <span className="text-emerald-400">{s.printed}</span> · <span className={s.pending ? "text-amber-300" : ""}>{s.pending}</span></span>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
